import Feature from 'ol/Feature';
import { unByKey } from 'ol/Observable';
import { easeOut } from 'ol/easing';
import Point from 'ol/geom/Point';
import { fromLonLat } from 'ol/proj';
import { Circle as CircleStyle, Stroke, Style } from 'ol/style';
import { getVectorContext } from 'ol/render';

// const randomLongitude = require('random-longitude');
// const randomLatitude = require('random-latitude');

export const strike = (config: any) => {
  const { source, map, tileLayer, distance, x, y } = config;

  function addRandomFeature() {
    var geometry = new Point(fromLonLat([x, y]));
    var feature = new Feature({
      geometry,
      distance
    });
    source && source.addFeature(feature);
  }

  // function addRandomFeature() {
  //     const y = randomLongitude({min: 45, max: 55});
  //     const x = randomLatitude({min: 10, max: 26});
  //     var geom = new Point(fromLonLat([x, y]));
  //     var feature = new Feature(geom);
  //     source.addFeature(feature);
  //   }

  var duration = 650;
  function flash(feature: any) {
    var start = new Date().getTime();
    var listenerKey = tileLayer.on('postrender', animate);

    function animate(event: any) {
      var vectorContext = getVectorContext(event);
      var frameState = event.frameState;
      var flashGeom = feature.getGeometry().clone();
      var elapsed = frameState.time - start;
      var elapsedRatio = elapsed / duration;
      var radius = easeOut(elapsedRatio) * 15 + 5;
      var opacity = easeOut(1 - elapsedRatio);

      var style = new Style({
        image: new CircleStyle({
          radius: radius,
          stroke: new Stroke({
            color: 'rgba(255, 0, 0, ' + opacity + ')',
            width: 0.35 + opacity
          })
        })
      });

      vectorContext.setStyle(style);
      vectorContext.drawGeometry(flashGeom);
      if (elapsed > duration) {
        unByKey(listenerKey);
        return;
      }

      map.render();
    }
  }

  source.once('addfeature', function(e: any) {
    flash(e.feature);
  });
  addRandomFeature();
  // //@ts-ignore
  // clearInterval(global.myVar);
  // //@ts-ignore
  // global.myVar = setInterval(myTimer, 200);

  // function myTimer() {
  //     addRandomFeature();
  // }
};
